import React from 'react'
import { Text, View, Image, Dimensions, TouchableOpacity } from 'react-native'
import * as Progress from 'react-native-progress'
import styles from './MyAdvanceStyles'
import theme from '../../../theme'
import { avatarPlaceholder } from '../customUtils/Constants'
import { colorFilled, colorUnfilled } from '../../../themeConstants'
import { ScrollView } from 'react-native-gesture-handler'
import { FlashList } from '@shopify/flash-list'
import { AdvanceTeamModel, AdvanceTeamRegion } from './models/MyAdvanceModel'
import { useNavigation } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import { DotsNavigation } from '../navigation/stacks/NavigationStack'

const { width } = Dimensions.get('window')

export const MyTeamAdvanceScreen = ({ route }) => {
    const regions: AdvanceTeamRegion[] = route?.params?.regions
    const updateDate: string = route?.params?.updateDate
    const navigation = useNavigation<StackNavigationProp<DotsNavigation>>()
    if (!regions || regions?.length === 0) {
        return (
            <View style={{ flex: 1, justifyContent: 'center' }}>
                <View style={styles.spacer2}></View>
                <Image source={require('../../../assets/advance/noDataEvaluations.png')} style={styles.noDataEvaluations} />
                <View style={styles.spacer1}></View>
                <View style={styles.spacer1}></View>
                <Text style={styles.noDataText}>No hay regiones para ver</Text>
                <View style={styles.spacer2}></View>
            </View>
        )
    }
    const onClickRegion = (region: AdvanceTeamRegion) => {
        const params = {
            regions: [region],
            updateDate: updateDate,
        }
        navigation.navigate('MyTeamAdvanceScreen', params)
    }
    const onClickTeam = (team: AdvanceTeamModel) => {
        let memberID = team._id
        let params = { id: memberID }
        navigation.navigate('MyTeamScreen', params)
    }
    return (
        <View style={styles.container}>
            <ScrollView showsVerticalScrollIndicator={false}>
                {regions.length > 1 ? (
                    <FlashList
                        data={regions}
                        horizontal={false}
                        keyExtractor={(item) => item._id.toString()}
                        numColumns={1}
                        showsHorizontalScrollIndicator={false}
                        showsVerticalScrollIndicator={false}
                        renderItem={({ item: region }) => <RegionItem region={region} onClickRegion={onClickRegion} card={true} />}
                    />
                ) : (
                    <View>
                        <RegionItemSingle region={regions[0]} onClickRegion={() => {}} card={false} />
                        <FlashList
                            data={regions[0].team}
                            horizontal={false}
                            keyExtractor={(item) => item._id.toString()}
                            numColumns={1}
                            showsHorizontalScrollIndicator={false}
                            showsVerticalScrollIndicator={false}
                            renderItem={({ item: team }) => <TeamItem team={team} onClickTeam={onClickTeam} />}
                        />
                    </View>
                )}

                <Text style={[styles.infoText, styles.alignCenter]}>{'Última actualización: ' + updateDate}</Text>
                <View style={styles.spacer2}></View>
            </ScrollView>
        </View>
    )
}

export const RegionItem = ({
    region,
    onClickRegion,
    card,
}: {
    region: AdvanceTeamRegion
    onClickRegion: (region: AdvanceTeamRegion) => void
    card: boolean
}) => {
    return (
        <TouchableOpacity
            style={[card ? styles.containerRowCard : [styles.containerRow, styles.padding], { pointerEvents: !card ? 'none' : null }]}
            onPress={() => onClickRegion(region)}
        >
            <View style={[styles.marginLeft, { flex: 1 }]}>
                <View style={{ justifyContent: 'center', alignItems: 'center' }}>
                    <Progress.Circle
                        size={92}
                        progress={0.3}
                        showsText={false}
                        textStyle={styles.percentage}
                        thickness={10}
                        color={theme.colors.colorPrimary}
                        unfilledColor={theme.colors.disabled}
                        borderWidth={0.1}
                        borderColor={theme.colors.colorSecondary}
                        strokeCap='round'
                        style={{ alignSelf: 'center' }}
                    />
                    {region.ranking && <Text style={[styles.percentageBis, styles.alignCenter, { position: 'absolute' }]}>{region.ranking}°</Text>}
                </View>
                {region.name && <View style={styles.spacer2}></View>}
                {region.name && <Text style={[styles.section, styles.marginHorizontal, styles.alignCenter]}>{region.name.toUpperCase()}</Text>}
            </View>

            <View style={{ flex: 2 }}>
                <TeamProgressView title='CONTENIDO VISTO' progress={region.watched_content ?? 0} color={colorFilled} />
                <TeamProgressView title='ÍNDICE SALESBOOK' progress={region.knowledge ?? 0} color={theme.colors.colorApproved} />
                <TeamProgressView title='CAPACIDAD TEÓRICA' progress={region.knowledge_technical ?? 0} color={theme.colors.colorInProgress} />
                <TeamProgressView title='CAPACIDAD PRÁCTICA' progress={region.knowledge_practical ?? 0} color={theme.colors.colorSecondary} />
            </View>
        </TouchableOpacity>
    )
}

export const RegionItemSingle = ({
    region,
    onClickRegion,
    card,
}: {
    region: AdvanceTeamRegion
    onClickRegion: (region: AdvanceTeamRegion) => void
    card: boolean
}) => {
    return (
        <TouchableOpacity
            style={[
                card ? styles.containerRowCard : [styles.containerRow, styles.padding],
                { pointerEvents: !card ? 'none' : null, justifyContent: 'space-between', backgroundColor: theme.colors.filtersBackground },
            ]}
            onPress={() => onClickRegion(region)}
        >
            <View style={styles.marginHorizontal}>
                {region.name && <Text style={styles.region}>Región</Text>}
                {region.name && <View style={styles.spacer1}></View>}
                {region.name && <Text style={styles.section}>{region.name.toUpperCase()}</Text>}
            </View>
            <View>
                <View style={[styles.marginHorizontal, { justifyContent: 'center', alignItems: 'center' }]}>
                    <Progress.Circle
                        size={60}
                        progress={0.3}
                        showsText={false}
                        textStyle={styles.percentage}
                        thickness={6}
                        color={theme.colors.colorPrimary}
                        unfilledColor={theme.colors.disabled}
                        borderWidth={0.1}
                        borderColor={theme.colors.colorSecondary}
                        strokeCap='round'
                        style={{ alignSelf: 'center' }}
                    />
                    {region.ranking && <Text style={[styles.percentageBis, styles.alignCenter, { position: 'absolute' }]}>{region.ranking}°</Text>}
                </View>
            </View>
        </TouchableOpacity>
    )
}

export const TeamItem = ({ team, onClickTeam }: { team: AdvanceTeamModel; onClickTeam: (team: AdvanceTeamModel) => void }) => {
    return (
        <TouchableOpacity style={styles.card} onPress={() => onClickTeam(team)}>
            <View style={styles.headerCard}>
                <Image source={{ uri: avatarPlaceholder }} style={styles.avatar} />
                <View style={styles.marginHorizontal}>
                    <Text style={styles.titleSection}>{team.level}</Text>
                    <View style={styles.spacerText}></View>
                    <Text style={styles.subtitleSection}>{team.name}</Text>
                    <View style={styles.spacerText}></View>
                    <Text style={styles.descriptionSection}>{team.role}</Text>
                </View>
            </View>
            <View style={styles.paddingBottom}>
                <TeamProgressView title='CONTENIDO VISTO' progress={team.watched_content ?? 0} color={colorFilled} />
                <TeamProgressView title='ÍNDICE SALESBOOK' progress={team.knowledge ?? 0} color={theme.colors.colorApproved} />
                <TeamProgressView title='CAPACIDAD TEÓRICA' progress={team.knowledge_technical ?? 0} color={theme.colors.colorInProgress} />
                <TeamProgressView title='CAPACIDAD PRÁCTICA' progress={team.knowledge_practical ?? 0} color={theme.colors.colorSecondary} />
            </View>
        </TouchableOpacity>
    )
}

export const TeamProgressView = ({ title, progress, color }) => {
    return (
        <View style={styles.containerProgress}>
            <View style={{ flex: 1 }}>
                <Text style={styles.subtitleModule}>{title}</Text>
                <View style={styles.spacer1}></View>
                <View style={{ flex: 1 }}>
                    <Progress.Bar
                        progress={progress / 100}
                        height={12}
                        width={null}
                        style={[styles.progressBar]}
                        color={color}
                        unfilledColor={colorUnfilled}
                    />
                </View>
                <View style={styles.spacer1}></View>
                <View style={styles.spacer1}></View>
                <View style={styles.spacer1}></View>
            </View>
        </View>
    )
}
